(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npDepartment', ['$document', function ($document) {
        return {
            restrict: 'E',
            controller: ['$scope', '$http', '$timeout', controller],
            controllerAs: 'vm',
            scope: {
                getDepartment: '=',
                dselected: '=',
                dselectedList: '=?',
                cssclass: '@',
                treeClass: '@',
                moduleClass: '@',
                indexControl: '=?'
            },
            templateUrl: '/app/shared/directives/department.tpl.html',
            link: function (scope, element, attr) {
                scope.isDropdownShown = false;
                scope.isSearchResultShown = false;
                $document.bind('click', function (event) {
                    var isClickedElementChildOfPopup = element
                      .find(event.target)
                      .length > 0;

                    if (isClickedElementChildOfPopup)
                        return;
                    scope.isDropdownShown = false;
                    scope.isSearchResultShown = false;
                    scope.$apply();
                });
            }
        };
    }]);

    function controller($scope, $http, $timeout) {
        var vm = this;

        vm.currentDepartmentIndex = -1;

        vm.selectDepartmentFromDropdown = selectDepartmentFromDropdown;
        vm.selectDepartmentFromSearchResult = selectDepartmentFromSearchResult;
        vm.handleExpand = handleExpand;
        vm.toggle = toggle;
        vm.clearDepartment = clearDepartment;
        vm.onDepartmentKeyup = onDepartmentKeyup;
        vm.onSearchDepartmentSelect = onSearchDepartmentSelect;
        vm.isDisabledDepartment = isDisabledDepartment;
        vm.showSearchResult = showSearchResult;
        vm.showDropdown = showDropdown;

        vm.initialize = function () {
            if ($scope.indexControl == undefined) {
                $scope.indexControl = '1';
            }
            vm.searchDepartments = [];
            $http.get('/api/Users/GetDepartments', { params: { departmentId: null, onlyTreeRootNode: true } })
               .success(function (data, status, headers, config) {
                   vm.departments = data;
                   angular.forEach(vm.departments, function (department) {
                       angular.extend(department, {
                           cssClass: 'fa fa-share-alt'
                       });
                   });

                   vm.selectedParentDepartment = $scope.dselected;
                   vm.selectedDepartment = angular.copy($scope.dselected);
                   if (vm.selectedParentDepartment != null && vm.selectedParentDepartment.name.length > 0) {
                       updateDepartmentGUI();
                   }
               })
               .error(function (data, status, headers, config) {
                   vm.departments = null;
               });
        }

        function selectDepartmentFromDropdown(node) {
            if ((vm.selectedDepartment != null && node.$modelValue.id == vm.selectedDepartment.id)
                || isDisabledDepartment($scope.dselected, $scope.dselectedList, node.$modelValue)) {
                return;
            }
            $scope.getDepartment(node.$modelValue);
            $scope.isDropdownShown = false;
            vm.selectedParentDepartment = node.$modelValue;
            updateDepartmentGUI();
        }

        function selectDepartmentFromSearchResult(department) {
            if (isDisabledDepartment($scope.dselected, $scope.dselectedList, department)) {
                return;
            }
            $scope.getDepartment(department);
            $scope.isSearchResultShown = false;
            vm.selectedParentDepartment = department;
            updateDepartmentGUI();
        }

        function handleExpand(expanded, itemId, selectedNode) {
            if (expanded == true) {

                //sibling is the data which bind with the scope. So if we modify sibling, it will reflect to $scope.list
                var siblings = selectedNode.$parentNodeScope == null ? selectedNode.vm.departments : selectedNode.$parentNodeScope.$modelValue.items;
                var modelValue = selectedNode.$modelValue;
                if (modelValue.isLoaded) {
                    return;
                } else {
                    modelValue.isLoaded = true;
                }

                $http.get('/api/Users/GetDepartments', { params: { departmentId: itemId } })
                     .success(function (data, status, headers, config) {
                         if (data != null && data.length > 0) {
                             var length = siblings.length;
                             for (var i = 0; i < length; i++) {
                                 if (siblings[i].id == itemId && siblings[i].id != 0) {
                                     angular.forEach(data, function (department) {
                                         angular.extend(department, {
                                             cssClass: 'fa fa-share-alt'
                                         });
                                     });

                                     if (siblings[i].items == null) {
                                         siblings[i].items = [];
                                     }
                                     siblings[i].items = siblings[i].items.concat(data);;
                                     break;
                                 }
                             }
                         }
                     })
                    .error(function (data, status, headers, config) {
                        // TODO: log error
                    });
            }
        }

        function toggle(scope) {
            scope.toggle();
        };

        function clearDepartment() {
            $(ELEMENT_SELECTORS.DepartmentSelectionInputSelector + $scope.indexControl).val('').focus();
            $(ELEMENT_SELECTORS.DepartmentSelectionContainerSelector + $scope.indexControl).removeClass(ELEMENT_SELECTORS.DepartmentContainerClassSelector);
            $(ELEMENT_SELECTORS.DepartmentSelectionClearSelector + $scope.indexControl).hide();
            vm.selectedParentDepartment = null;
            $scope.getDepartment({
                address1: '',
                address2: '',
                address3: '',
                country: '',
                countryId: null,
                cssClass: '',
                description: '',
                email: '',
                fax: '',
                id: null,
                isCompany: false,
                name: '',
                organizationNo: '',
                parentId: null,
                path: '',
                phone: '',
                url: '',
                visitAddress1: '',
                visitAddress2: '',
                visitAddress3: ''
            });
        };

        function onDepartmentKeyup(e) {
            if ((e.which === 8 || e.which == 46)) {
                if ($(e.target).val() == '') {
                    $(ELEMENT_SELECTORS.DepartmentSelectionContainerSelector + $scope.indexControl).removeClass(ELEMENT_SELECTORS.DepartmentContainerClassSelector);
                }
            } else {
                if ($(e.target).val() != '') {
                    updateDepartmentGUI();
                }
            }

            if (vm.selectedParentDepartment) {
                getDepartmentsOnTyping(vm.selectedParentDepartment.path);
            }

            onDataNavigating(e);
        };

        function updateDepartmentGUI() {
            $timeout(function () {
                $(ELEMENT_SELECTORS.DepartmentSelectionInputSelector + $scope.indexControl).next().toggle(Boolean($(ELEMENT_SELECTORS.DepartmentSelectionInputSelector + $scope.indexControl).val()));
                $(ELEMENT_SELECTORS.DepartmentSelectionContainerSelector + $scope.indexControl).addClass(ELEMENT_SELECTORS.DepartmentContainerClassSelector);
                $(ELEMENT_SELECTORS.DepartmentSelectionInputSelector + $scope.indexControl).focus();
            }, 0, false);
        };

        function onSearchDepartmentSelect($item, $model, $label) {
            if (!isDisabledDepartment($scope.dselected, $scope.dselectedList, $item)) {
                $scope.getDepartment($item);
                vm.selectedParentDepartment = $item;
                updateDepartmentGUI();
            } else {
                clearDepartment();
            }
        };

        function isDisabledDepartment(dselected, dselectedList, department) {
            if (dselected) {
                if (department.id == dselected.id) {
                    return true;
                }
            }

            if (dselectedList) {
                for (var i = 0; i < dselectedList.length; i++) {
                    if (department.id == dselectedList[i].id) {
                        return true;
                    }
                }
            }

            return false;
        }

        function getDepartmentsOnTyping(keyword) {
            if (keyword.length >= 2) {
                $http.get(handbookRequests.SearchDepartmentsRequest, {
                    params: { 'keyword': keyword }
                })
                .then(function (response, status, headers, config) {
                    vm.searchDepartments = response.data;
                    angular.forEach(vm.searchDepartments, function (department) {
                        angular.extend(department, {
                            cssClass: 'fa fa-share-alt'
                        });
                    });
                });
            } else {
                vm.searchDepartments = [];
            }
        };

        $scope.$watch('dselected', function (newValue, oldValue) {
            if (newValue != null && newValue != oldValue) {
                vm.selectedParentDepartment = newValue;
                vm.selectedDepartment = newValue;
                updateDepartmentGUI();
            }
        });

        function showSearchResult() {
            $scope.isDropdownShown = false;
            $scope.isSearchResultShown = true;
            vm.selectedDepartment = null;
        }

        function showDropdown() {
            $scope.isSearchResultShown = false;
            $scope.isDropdownShown = true;
        }

        function onDataNavigating($event) {
            if (($event.which == 38 || $event.which == 40) && $scope.isSearchResultShown) {
                setCurrentItemInSearchResult($event.which);
            } else if ($event.which == 13 && vm.currentSearchDepartment) {
                selectDepartmentFromSearchResult(vm.currentSearchDepartment)
            }
        }

        function setCurrentItemInSearchResult(keyCode) {
            if (keyCode == 38 && vm.currentDepartmentIndex > 0) {
                vm.currentDepartmentIndex -= 1;
            }

            if (keyCode == 40 && vm.currentDepartmentIndex < vm.searchDepartments.length - 1) {
                vm.currentDepartmentIndex += 1;
            }

            if ((keyCode == 38 || keyCode == 40) && (vm.currentDepartmentIndex < vm.searchDepartments.length)) {
                vm.currentSearchDepartment = vm.searchDepartments[vm.currentDepartmentIndex];
            }
        }
    }

})();